import React, { useState, useEffect } from "react";
import { getLoggedInUser } from "../helpers";
import {
  Container,
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { betSlipService } from "../redux/betslip/services";
import Loader from "./Loader/Loader";
import "react-datepicker/dist/react-datepicker.css";
import WithdrawRequests from "../pages/WithdrawRequests";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "react-i18next";

const WithdrawList = (props) => {
  const [user, setUser] = useState(getLoggedInUser());
  const [startDate, setStartDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(-1);
  const [pageSize, setPageSize] = useState(10);
  const [pageSizeOptions] = useState([10, 20, 30, 40, 50, 100]);
  const [currentPage, setCurrentPage] = useState(0);
  const [tableSorting, setTableSorting] = useState([
    { columnName: "title", direction: "asc" },
  ]);
  const { t } = useTranslation();
  const [tableFilter, setTableFilter] = useState([]);
  const [withdrawList, setWithdrawList] = useState([]);
  const [manageUserService, setManageUserService] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    loadUserWalletTables();
    manageUserServices();
  }, []);


  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const loadUserWalletTables = () => {
    const columnSorting = tableSorting[0];
    let curPage = currentPage + 1;
    var reqData = {
      guid: user.guid,
      page_size: pageSize,
      page: curPage,
      search: tableFilter,
    };
    if (columnSorting) {
      const sortingDirectionString =
        columnSorting.direction === "desc" ? "desc" : "asc";
      reqData["sort_by"] = columnSorting.columnName;
      reqData["sort_order"] = sortingDirectionString;
    }
    setIsLoading(true);
    betSlipService
      .userWithdrawList(reqData)
      .then((response) => {
        setIsLoading(false);
        setWithdrawList(response.data);
        setTotalItemCount(response.total);
        setTotalPageCount(response.last_page);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handlePerRowsChange = (perPage) => {
    setPageSize(perPage);
    loadUserWalletTables();
  };

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
    loadUserWalletTables();
  };

  const handleSortChange = (tableSorting) => {
    let sortVal = [];
    tableSorting?.map((value) =>
      sortVal.push({
        columnName: value?.id || "defaultColumn",
        direction: value?.desc === true ? "desc" : "asc",
      })
    );
    setTableSorting(sortVal);
    loadUserWalletTables();
  };

  const handleFilterChange = (tableFilter) => {
    setTableFilter(tableFilter);
    loadUserWalletTables();
  };

  const renderRedirectToRoot = () => { };

  const manageUserServices = () => {
    var reqData = {
      guid: user && user.guid ? user.guid : "",
    };
    betSlipService
      .manageuserServices(reqData)
      .then((response) => {
        setManageUserService(response.data);
      })
      .catch((error) => {
        console.log(error);
        console.log("error");
      });
  };
  const onTrigger = () => {
    props.parentCallback(true);

  };


  let loading;
  if (isLoading) {
    loading = <Loader />;
  }
  return (
    <React.Fragment>
      {renderRedirectToRoot()}

      {
        <div className="account-pages">
          <div className="withdraw-request-popup">
            <div className="withdraw-request-popup1">
              <Modal
                className="withdraw-request-popup"
                isOpen={isModalOpen}
              // toggle={toggleModal}
              >
                {/* <ModalHeader toggle={toggleModal}></ModalHeader> */}
                <ModalBody>

                  <p onClick={toggleModal}>
                    <RxCross2 className="close-btn" />
                  </p>
                  <WithdrawRequests 
                    setIsModalOpen={setIsModalOpen}
                  />
                </ModalBody>

              </Modal>
            </div>
          </div>

          <section className="dashboard-section padding-top padding-bottom">
            <Container>
              <Row>
                <Col className="col-lg-12 col-md-12 col-sm-12">
                  <div className="user-toggler-wrapper d-flex align-items-center d-lg-none">
                    <h4 className="title m-0">Menu</h4>
                    <div className="user-toggler" onClick={() => onTrigger()}>
                      <i className="las la-sliders-h"></i>
                    </div>
                  </div>
                  <Col
                    style={{ display: "flex", justifyContent: "end" }}
                    className="col-lg-12 col-md-12 col-sm-12 text-right"
                  >
                    {manageUserService.withdrawal_status === 0 ? (
                      <Link
                        type="button"
                        className="casino-btn-withdraw"
                        onClick={() =>
                          swal({
                            icon: "info",
                            title: "Note",
                            text: "Your withdraw request has been paused by the admin. If you wish to proceed, please contact our administrator on admin@stotngo.com.",
                            confirmButtonText: "OK",
                          })
                        }
                      >
                        {t("userProfile.withdrawRequests.title")}
                      </Link>
                    ) : (
                      <Link
                        type="button"
                        className="casino-btn-withdraw"
                        onClick={() => toggleModal()}
                      >
                        {t("userProfile.withdrawRequests.title")}
                      </Link>
                    )}
                  </Col>
                  <div className="table--responsive--md mt-3">
                    {/* <a className="wallet-btn mt-3 mb-2" target="" href="/add-amount">Add Amount</a> */}
                    <Card style={{ minHeight: "425px" }}>
                      <CardBody className="bg-dark1  user-data">
                        <ReactTable
                          data={withdrawList}
                          columns={[
                            {
                              Header: t("userProfile.withdrawRequests.id"),
                              accessor: "id",
                              filterable: false,
                              sortable: false,
                              className: "text-center",
                              Cell: (row) => (
                                <div
                                  style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {row.value ? row.value : "--"}
                                </div>
                              ),
                            },

                            {
                              Header: (
                                <div
                                  style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                    {t("userProfile.withdrawRequests.amount")}
                                </div>
                              ),
                              accessor: "amount",
                              filterable: false,
                              sortable: false,
                              className: "text-center",
                              Cell: (row) => (
                                <span>
                                  {row.value ? "€" : ""}
                                  {row.value ? row.value : "--"}
                                </span>
                              ),
                            },
                            {
                              Header: (
                                <div
                                  style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                    {t("userProfile.withdrawRequests.reason")}
                                </div>
                              ),
                              accessor: "reason",
                              filterable: false,
                              sortable: false,
                              className: "text-center",
                              Cell: (row) => (
                                <div
                                  style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {row.value ? row.value : "--"}
                                </div>
                              ),
                            },

                            {
                              Header: (
                                <div
                                  style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                {t("userProfile.withdrawRequests.status")}
                                </div>
                              ),
                              accessor: "status",
                              filterable: false,
                              sortable: false,
                              className: "text-center",

                              Cell: (row) => {
                                let status;
                                switch (row.value) {
                                  case 0:
                                    status = t("userProfile.uploadDocument.actions.rejected");
                                    break;
                                  case 1:
                                    status = t("userProfile.uploadDocument.actions.approved");
                                    break;
                                  case 2:
                                    status = t("userProfile.uploadDocument.actions.pending");
                                    break;
                                  case 3:
                                    status =  t("userProfile.uploadDocument.actions.pending");
                                    break;
                                  default:
                                    status = "";
                                    break;
                                }
                                return <span>{status}</span>;
                              },
                            },

                            {
                              Header: (
                                <div
                                  style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {t("userProfile.withdrawRequests.requestedAt")}
                                </div>
                              ),
                              accessor: "requested_date",
                              filterable: false,
                              sortable: false,
                              className: "text-center",

                              Cell: (row) => (
                                <div
                                  style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {row.value ? row.value : "--"}
                                </div>
                              ),
                            },
                          ]}
                          loading={isLoading}
                          defaultPageSize={pageSize}
                          pageSizeOptions={pageSizeOptions}
                          sortable={true}
                          multiSort={false}
                          resizable={true}
                          filterable={true}
                          onSortedChange={handleSortChange}
                          onPageSizeChange={handlePerRowsChange}
                          onPageChange={handlePageChange}
                          onFilteredChange={handleFilterChange}
                          manual={true}
                          minRows="0"
                          pages={totalPageCount}
                          showPagination={withdrawList?.length > 0} // Conditionally hide pagination
                          NoDataComponent={() => (
                            <div
                              style={{
                                textAlign: "center",
                                padding: "1rem",
                              }}
                            >
                            {t("userProfile.withdrawRequests.noWithdrawals")}
                            </div>
                          )}
                        />
                      </CardBody>
                    </Card>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      }
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.Auth;
  return user;
};
export default connect(mapStateToProps)(WithdrawList);
